<template>
  <div class="view-wrapper">

    <div class="search-container elevation-1 white px-3 pt-2 pb-2 d-flex flex-column">
      <v-radio-group 
        v-model="tipoBusca" 
        row 
        hide-details 
        class="mt-0 mb-3" 
        @change="focarInputBusca"
      >
        <v-radio label="Descrição" value="descricao" color="primary"></v-radio>
        <v-radio label="Código" value="codigo" color="primary"></v-radio>
      </v-radio-group>

      <div class="d-flex align-center" style="width: 100%;">
        <v-text-field
          ref="campoBusca"
          v-model="termoBusca"
          :label="labelBusca"
          outlined
          dense
          clearable
          hide-details
          class="mr-2"
          @keydown.enter="forcarBusca('qualquer')"
        ></v-text-field>

        <v-btn 
          height="40"
          width="70"
          min-width="40"
          class="px-2 mr-2"
          color="primary" 
          elevation="2" 
          @click="forcarBusca('inicio')"
          title="Buscar pelo Início"
        >
          <v-icon>mdi-arrow-left-thick</v-icon>
        </v-btn>

        <v-btn 
          height="40"
          width="70"
          min-width="40"
          class="px-2"
          color="primary" 
          elevation="2" 
          @click="forcarBusca('qualquer')"
          title="Buscar em Qualquer Parte"
        >
          <v-icon>mdi-arrow-left-thick</v-icon><v-icon>mdi-arrow-right-thick</v-icon>
        </v-btn>
      </div>
    </div>

    <div class="content-container elevation-2">
      <div v-if="loading" class="text-center pa-8">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
        <p class="mt-4 mb-0">{{ textoLoading }}</p>
      </div>

      <div v-else-if="!loading && resultados.length === 0" class="text-center pa-8">
        <p class="mb-0">Nenhum registro encontrado.</p>
      </div>

      <RecycleScroller
        v-else
        ref="scrollerComponent" 
        class="scroller" 
        :items="resultados"
        :item-size="72" 
        :buffer="1000" 
        key-field="id"
        v-slot="{ item }"
      >
        <v-list-item
          class="list resultado-item-clicavel px-3"
          :class="{ 'item-selecionado': itemSelecionado === item }"
          style="height: 72px; border-bottom: 1px solid #e0e0e0;"
          @click="selecionarEVoltar(item)"
        >
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium text-truncate">
              {{ item.descricao }}
            </v-list-item-title>
            
            <v-list-item-subtitle class="mt-1 grey--text text--darken-1">
              <span>Cód: <span class="font-weight-medium">{{ item.codigo }}</span></span>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </RecycleScroller>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import db from '@/plugins/dexie';

Vue.use(VueVirtualScroller)

export default {
  name: 'PesquisaMarcaCorIndex',
  
  data() {
    return {
      termoBusca: this.$route.query.busca || '',
      tipoBusca: this.$route.query.tipoBusca || 'descricao', 
      modoBusca: this.$route.query.modoBusca || 'qualquer',

      loading: false, 
      textoLoading: 'Carregando dados...',
      itemSelecionado: null,
      resultados: [], 
    };
  },

  watch: {
    '$route.query': {
      immediate: true,
      deep: true,
      handler(novoQuery, antigoQuery) {
        if (novoQuery.busca !== undefined && novoQuery.busca !== this.termoBusca) {
          this.termoBusca = novoQuery.busca || '';
        }

        if (!antigoQuery) {
          this.iniciarProcesso();
          return;
        }
        
        const mudouTabela = novoQuery.tabela !== antigoQuery.tabela || novoQuery.tipo !== antigoQuery.tipo;
        const mudouBusca = novoQuery.busca !== antigoQuery.busca;
        const mudouTipo = novoQuery.tipoBusca !== antigoQuery.tipoBusca;
        const mudouModo = novoQuery.modoBusca !== antigoQuery.modoBusca;
        
        if (mudouTabela || mudouBusca || mudouTipo || mudouModo) {
          this.iniciarProcesso();
        }
      },
    },
  },

  computed: {
    tabelaAtual() {
      const tab = (this.$route.query.tabela || this.$route.query.tipo || 'cor').toLowerCase();
      if (tab === 'marca' || tab === 'marcaveiculo') return 'marcaveiculo';
      return 'cor';
    },

    labelBusca() {
      if (this.tipoBusca === 'codigo') return 'Buscar por Código';
      return 'Buscar por Descrição';
    }
  },

  methods: {
    focarInputBusca() {
      this.$nextTick(() => {
        if (this.$refs.campoBusca) {
          this.$refs.campoBusca.focus();
          const nativeInput = this.$refs.campoBusca.$el.querySelector('input');
          if (nativeInput) {
            nativeInput.select();
          }
        }
      });
    },

    removerAcentos(texto) {
      if (!texto) return '';
      return texto.toString().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
    },

    forcarBusca(modoSelecionado = null) {
      if (modoSelecionado) {
        this.modoBusca = modoSelecionado;
      }
      
      const query = { ...this.$route.query };
      const buscaLimpa = this.termoBusca ? this.termoBusca.trim() : '';

      if (buscaLimpa !== '') {
        query.busca = buscaLimpa;
        query.modoBusca = this.modoBusca;
      } else {
        delete query.busca;
        delete query.modoBusca;
      }

      query.tipoBusca = this.tipoBusca;

      if (this.$route.query.busca !== query.busca || 
          this.$route.query.tipoBusca !== query.tipoBusca ||
          this.$route.query.modoBusca !== query.modoBusca) {
        this.$router.replace({ query }).catch(() => {});
      } else {
        this.iniciarProcesso();
      }
    },

    async iniciarProcesso() {
      this.itemSelecionado = null;
      this.loading = true;
      await this.carregarPaginaVisualizacao();
      this.loading = false;
      this.focarInputBusca();
    },

    async carregarPaginaVisualizacao() {
      try {
        const { busca, tipoBusca, modoBusca } = this.$route.query;
        const filtroBusca = busca ? busca.toLowerCase().trim() : null;
        const tipoBuscaAtivo = tipoBusca || 'descricao';
        const modoBuscaAtivo = modoBusca || 'qualquer';

        const tabela = this.tabelaAtual;
        let dadosBrutos = [];

        if (tabela === 'cor') {
          this.textoLoading = 'Carregando cores...';
          dadosBrutos = await db.cor.toArray();
        } else if (tabela === 'marcaveiculo') {
          this.textoLoading = 'Carregando marcas de veículo...';
          dadosBrutos = await db.marcaveiculo.toArray();
        }

        if (filtroBusca) {
          const termoSemAcento = this.removerAcentos(filtroBusca);

          dadosBrutos = dadosBrutos.filter(item => {
            let valorCampo = '';
            
            if (tipoBuscaAtivo === 'codigo') {
              if (tabela === 'cor') {
                valorCampo = (item.coridcor || item.coridnuvem || item.id || '').toString();
              } else {
                valorCampo = (item.mavidmarcaveiculo || item.mavidnuvem || item.id || '').toString();
              }
              
              if (modoBuscaAtivo === 'inicio') {
                return valorCampo.toLowerCase().startsWith(filtroBusca);
              } else {
                return valorCampo.toLowerCase().includes(filtroBusca);
              }
            } else {
              if (tabela === 'cor') {
                valorCampo = item.cordescricao || '';
              } else {
                valorCampo = item.mavdescricao || '';
              }
              
              const valorSemAcento = this.removerAcentos(valorCampo.toLowerCase());
              if (modoBuscaAtivo === 'inicio') {
                return valorSemAcento.startsWith(termoSemAcento);
              } else {
                return valorSemAcento.includes(termoSemAcento);
              }
            }
          });
        }
        
        this.resultados = dadosBrutos.map(item => this.mapearItemParaView(item, tabela));
        return true;

      } catch (e) {
        console.error("Erro ao carregar dados do Dexie:", e);
        return false;
      }
    },

    mapearItemParaView(item, tabela) {
      if (tabela === 'cor') {
        const idVal = item.coridcor || item.coridnuvem || item.id;
        const descVal = item.cordescricao || '';
        return {
          id: idVal,
          codigo: idVal,
          descricao: descVal,
          tipo: 'Cor',
          raw: item
        };
      } else {
        const idVal = item.mavidmarcaveiculo || item.mavidnuvem || item.id;
        const descVal = item.mavdescricao || '';
        return {
          id: idVal,
          codigo: idVal,
          descricao: descVal,
          tipo: 'MarcaVeiculo',
          raw: item
        };
      }
    },

    selecionarEVoltar(item) {
      if (!item) return;

      const dadosParaRetorno = {
        tipo: item.tipo,
        id: item.id,
        codigo: item.codigo,
        descricao: item.descricao,
        nome: item.descricao,
        ...item.raw
      };

      sessionStorage.setItem('pesquisaResultado', JSON.stringify(dadosParaRetorno));

      if (this.tabelaAtual === 'cor') {
        sessionStorage.setItem('cor_selecionada_retorno', JSON.stringify(dadosParaRetorno));
      } else {
        sessionStorage.setItem('marca_selecionada_retorno', JSON.stringify(dadosParaRetorno));
      }

      this.$router.back();
    }
  },

  mounted() {
    this.focarInputBusca();
  }
};
</script>

<style scoped>
.view-wrapper {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 56px);
}
.content-container {
  width: 100%;
  flex-grow: 1;
  overflow: hidden;
  position: relative;
}
.scroller {
  height: 100%;
  overflow-y: auto;
}
.scroller::-webkit-scrollbar {
  width: 12px;
}
.scroller::-webkit-scrollbar-thumb {
  background: rgba(76, 111, 175, 0.4);
  border-radius: 4px;
}
.scroller::-webkit-scrollbar-thumb:hover {
  background-color: #ccc;
}

.resultado-item-clicavel {
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.resultado-item-clicavel:hover {
  background-color: #f5f5f5;
}
.item-selecionado {
  background-color: #E3F2FD !important;
}
.list {
  background-color: white;
}

::v-deep .v-input--radio-group__input {
  display: flex;
  width: 100%;
}
::v-deep .v-radio {
  margin-right: 16px !important;
}
</style>
